import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

export interface BackofficeAccessResponse {
  version: number;
  modules: Record<string, boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class BackofficeAccessService {
  private baseUrl = environment.apiUrl;

  modules = signal<Record<string, boolean>>({});

  constructor(private http: HttpClient) {}

  loadAccess() {
    return this.http
      .get<BackofficeAccessResponse>(`${this.baseUrl}/backoffice/me/access`)
      .pipe(
        tap((response) => {
          const modules = response.modules || {};

          this.modules.set(modules);
          localStorage.setItem('backoffice_access', JSON.stringify(modules));
        }),
      );
  }

  hasModule(moduleKey: string): boolean {
    return this.modules()[moduleKey] === true;
  }

  hasModuleKey(moduleKey: string): boolean {
    return moduleKey in this.modules();
  }
}
